module.exports = __webpack_public_path__ + "img/room.5f974127.png";